import React, {useEffect, useState} from "react";
import Section1 from "../../components/Section1";
import LayoutsList from "../../components/LayoutsList";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import { apiUrl, assetsUrl } from "../../config/Config";
import axios from "axios";

import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";

import { useDispatch, useSelector } from 'react-redux';


const VerifyEmailAddress = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch(); 
  const inkcustomerdata = useSelector((store) => store.userReducer.inkcustomerdata);
  console.log('inkcustomerdata >>', inkcustomerdata);

    const [fullname, setfullname] = useState("");
    const [emailaddress, setemailaddress] = useState("");
    const [phonenumber, setphonenumber] = useState("");
    const [password, setpassword] = useState("");
    const [repassword, setrepassword] = useState("");

    const [otptext, setotptext] = useState("");

    const [otpSent, setOtpSent] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(120); // 2 minutes
    const [canResend, setCanResend] = useState(false);

    const [showloading, setshowloading] = useState(false);

    const { state } = useLocation();
    // console.log('state?.semail >>', state?.semail);
    // console.log('state?.screen >>', state?.screen);
    // console.log('screen >>', screen);
  
    const formatTime = (secs) => {
      const min = Math.floor(secs / 60);
      const sec = secs % 60;
      return `${min}:${sec < 10 ? "0" : ""}${sec}`;
    };
  
    const resendotpfunc = async() => {
      // const { isValid, mobile } = normalizeAndValidateIndianMobile(state?.mobile);
      // if (!isValid) {
      //   alert("Invalid mobile number");
      //   return;
      // } else {
      // }
      var data = {
      emailaddress: state?.semail
    }
    console.log('data >>', data);
  
    try {
      const res = await axios.post(
        apiUrl + "user-verify-resendotp-with-email",
        data,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
  
      if (res.data.status === "success") {
        alert('OTP sent to your registered email address.')
        setSecondsLeft(120);
        setCanResend(false);
  
      } else {
        alert(res.data.message || "Something went wrong.");
      }
    } catch (err) {
      console.error(err);
      alert(
        "Error logging in: " +
          (err.response?.data?.message || err.message || "Network error.")
      );
    } finally {
      // setLoading(false);
    }
      
    }

    const handleverifyfunct = async() => {
      
      var data = {
        otptext: otptext,
        emailaddress: state?.semail,
        screen: state?.screen
      }
      console.log('data >>', data);
      // return;
      setshowloading(true);
    
      try {
        const res = await axios.post(
          apiUrl + "user-verifyotp-with-email",
          data,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );
    
        if (res.data.status === "success") {
          setshowloading(false);
          if(state?.screen == "signup") {
            const frompagetologin = localStorage.getItem("frompagetologin");
            if(frompagetologin) {
              // Keep the checkout destination until the new user signs in.
              navigate('/login');
            } else {
              dispatch({ type: "inkcustomerdata", payload: res.data.data })
              navigate('/user-profile');
            }

            // navigate('/user-profile');
            // navigate('/');
          } else {
            navigate('/reset-password', {
              state: {
                emailaddress: state?.semail
              }
            });
          }
    
        } else {
          setshowloading(false);
          alert(res.data.message || "Something went wrong.");
        }
      } catch (err) {
        setshowloading(false);
        console.error(err);
        alert(
          "Error logging in: " +
            (err.response?.data?.message || err.message || "Network error.")
        );
      } finally {
        // setLoading(false);
        setshowloading(false);
      }
      
    }

    useEffect(() => {
      if (!otpSent) return;
  
      if (secondsLeft === 0) {
        setCanResend(true);
        return;
      }
  
      const timer = setInterval(() => {
        setSecondsLeft((prev) => prev - 1);
      }, 1000);
  
      return () => clearInterval(timer);
    }, [otpSent, secondsLeft]);

    useEffect(() => {
      setOtpSent(true);
      setSecondsLeft(120);
      setCanResend(false);
    }, [])
  

    

    return (
      <div className="homepage-layout">
        <section>
          <div className=" findlayout_section1main regsiterpagemaindiv">
            <div className="container">
              <div className="registermaindiv">
                <p className="section1title">
                  <span className="gradient-head">Verify Email</span>
                </p>
                <div className="register-inputdiv">
                  <label>Email Address *</label>
                  <input
                    type="text"
                    value={state?.semail}
                    // onChange={(t) => {
                    //   setemailaddress(t.target.value);
                    // }}
                    disabled
                    className="register-textinput form-control"
                    placeholder="Enter your email address"
                  />
                </div>
                <div className="register-inputdiv">
                  <label>Enter OTP sent to your email address *</label>
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={otptext}
                    onChange={(e) => {
                        const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                        setotptext(onlyNumbers);
                      }}
                      maxLength={6}
                    className="register-textinput form-control"
                    placeholder="Enter 6 digits OTP"
                  />
                </div>
                <div className="resetpassworddiv">
            {!canResend ? (
            <p style={{fontWeight: 400}}>
              Resend OTP in <strong>{formatTime(secondsLeft)}</strong>
            </p>
          ) : (
            <p style={{cursor: 'pointer'}} onClick={() => {resendotpfunc()}}>Resend OTP</p>
          )}
              </div>
                <div className="registersubmitbtn" onClick={() => {
                  if(showloading) {

                  } else {
                    handleverifyfunct()
                  }
                  
                  }}>
                { showloading ?
                  <div className="spinnermaindiv">
                  <Spinner
                    color="#fff"
                    size={16}
                    className="spinnerCenter"
                  />
                </div> :
                <p>Verify</p>
                }
                  
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
}

export default VerifyEmailAddress
